import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { BiTimeChart } from '@/features/dashboard-finance/charts/BiTimeChart';
import { formatUsdCents } from '@/features/dashboard-finance/formatters';

/** Receita direta mensal atual por país, em USD eq., ordenada do maior para o menor. */
export function RevenueByCountryChart({
  byCountryUsdCents,
}: {
  byCountryUsdCents: Record<string, number>;
}): React.JSX.Element {
  const { t } = useTranslation();
  const data = Object.entries(byCountryUsdCents)
    .map(([country, cents]) => ({ x: country, y: cents / 100 }))
    .sort((a, b) => b.y - a.y);

  return (
    <BiTimeChart
      title={t('sales.charts.revenueByCountry')}
      type="bar"
      data={data}
      color="#6366f1"
      valueFormatter={(v): string => formatUsdCents(Math.round(v * 100))}
    />
  );
}
